/// JTF3-added-AB-22-05-12

'use strict'

jQuery(document).ready(function($) {
	$(document).on('click', '.trigger__modal', function(e) {
		e.preventDefault();
		const body = $('body');
		body.addClass('modal__open');

		var data = $(this).data('embed'),
			type = $(this).data('type'),
			modal = '';

		switch ( type ) {
			case 'image':
				modal = '<div class="modal__container"><div class="modal__container--inner" style="background-image: url(' + data + ');"><a class="close__modal" href="#"><i class="fal fa-times"></i></a></div></div>';
				break;
			case 'youtube':
				modal = '<div class="modal__container"><div class="modal__container--inner"><iframe width="100%" height="315" src="https://www.youtube.com/embed/' + data + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe><a class="close__modal" href="#"><i class="fal fa-times"></i></a></div></div>';
				break;
			case 'login':
				modal = '<div class="modal__container"><div class="modal__container--inner"><div class="modal__container--login"><h2>Site Login </h2>' + $('.hidden__loginform').html() + '</div><a class="close__modal" href="#"><i class="fal fa-times"></i></a></div></div>';
				break;
			case 'html':
				var textcontents = $('#' + data).html();
				modal = '<div class="modal__container"><div class="modal__container--inner"><div class="modal__container--html"><div class="modal__container--scrollable">' + textcontents + '</div></div><a class="close__modal" href="#"><i class="fal fa-times"></i></a></div></div>';
				break;
			default:
				break;
		}

		body.append(modal);
	});

	$(document).on('click', '.modal__container--login', function(e) {
		e.stopPropagation();
	});

	$(document).on('click', '.close__modal', function(e) {
		e.preventDefault();
		$('.modal__container').remove();
		$('body').removeClass('modal__open');
	});
});

